import { css } from 'styled-components'

export const CustomFormBordersStyles = css`
  .react-tel-input {
    .form-control {
      border-color: #999999 !important;

      &:hover:not(:disabled) {
        border-color: #7a7a7a !important;
      }

      &:focus {
        border-color: var(--system-focus, #1677ff) !important;
        box-shadow: 0 0 0 2px var(--system-focus-shadow, rgba(22, 119, 255, 0.2)) !important;
      }
    }

    .flag-dropdown {
      border-color: #999999 !important;

      &:hover {
        border-color: #7a7a7a !important;
      }
    }
  }

  .react-phone-input-2 {
    input.form-control {
      border-color: #999999 !important;

      &:hover:not(:disabled) {
        border-color: #7a7a7a !important;
      }

      &:focus {
        border-color: var(--system-focus, #1677ff) !important;
        box-shadow: 0 0 0 2px var(--system-focus-shadow, rgba(22, 119, 255, 0.2)) !important;
      }
    }
  }

  input[type='text'].react-input-mask,
  .react-input-mask input {
    border-color: #999999 !important;

    &:hover:not(:disabled) {
      border-color: #7a7a7a !important;
    }

    &:focus {
      border-color: var(--system-focus, #1677ff) !important;
      outline: none !important;
      box-shadow: 0 0 0 2px var(--system-focus-shadow, rgba(22, 119, 255, 0.2)) !important;
    }
  }

  .imask-input {
    border-color: #999999 !important;

    &:hover {
      border-color: #7a7a7a !important;
    }

    &:focus {
      border-color: var(--system-focus, #1677ff) !important;
      outline: none !important;
      box-shadow: 0 0 0 2px var(--system-focus-shadow, rgba(22, 119, 255, 0.2)) !important;
    }
  }

  .custom-input,
  .custom-select,
  .custom-textarea {
    border-color: #999999 !important;

    &:hover {
      border-color: #7a7a7a !important;
    }

    &:focus,
    &:focus-within {
      border-color: var(--system-focus, #1677ff) !important;
      outline: none !important;
      box-shadow: 0 0 0 2px var(--system-focus-shadow, rgba(22, 119, 255, 0.2)) !important;
    }
  }

  .json-form-input {
    input,
    select,
    textarea {
      border-color: #999999 !important;

      &:hover {
        border-color: #7a7a7a !important;
      }

      &:focus {
        border-color: var(--system-focus, #1677ff) !important;
        outline: none !important;
        box-shadow: 0 0 0 2px var(--system-focus-shadow, rgba(22, 119, 255, 0.2)) !important;
      }
    }
  }

  .ace_editor {
    border-color: #999999 !important;

    &:hover {
      border-color: #7a7a7a !important;
    }

    &.ace_focus {
      border-color: var(--system-focus, #1677ff) !important;
      box-shadow: 0 0 0 2px var(--system-focus-shadow, rgba(22, 119, 255, 0.2)) !important;
    }
  }

  .color-picker-input {
    border-color: #999999 !important;

    &:hover {
      border-color: #7a7a7a !important;
    }
  }
`

export default CustomFormBordersStyles
